import { Button, withStyles } from "@material-ui/core";

const DangerButton = withStyles({
  root: {
    textTransform: "none",
    fontSize: 14,
    padding: "6px 12px",
    border: "none",
    lineHeight: 1.5,
    backgroundColor: "#D70000",
    borderColor: "#D70000",
    height: 40,
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#EB455F",
      borderColor: "#D70000",
    },
    "&:active": {
      backgroundColor: "#EB455F",
      borderColor: "#D70000",
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.12)",
      border:'none',
      color: "rgba(0, 0, 0, 0.26)",
      boxShadow: "none",
    },
  },
})(Button);

export default DangerButton;
